/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from "react-router-dom";

export default function Header() {
  return <header id="header">
    <div className="upper-part">
      <div className="container cosl-h-m">
        <div className="row">
          <div className="col-md-12 d-md-flex">
            <Link
              className="navbar-brand"
              to={{ pathname: "https://reliancejewels.com/" }}
              target="_blank"
            >
              <img
                src="https://image.reliancejewels.com/Jewels/cms_hydrant/widgets/HS18Logo/HorizontalBannerImage_1593441799728.png"
                alt="welcome to Reliancejewels store locator"
                title="welcome to Reliancejewels store locator"
              />
            </Link>
            <div id="free-eyecheckup" className="desktopview">
              <Link to="https://wa.me/918929853854?text=what%20is%20my%20eye%20power">
                <i className="fa fa-whatsapp" aria-hidden="true" /> Know
                Your Eye Power
              </Link>
            </div>
            <ul className="navbar-nav flex-row ml-md-auto d-md-flex nav-flex-icons desktopview tabletview">
              <li className="toll_free_number_national">
                <i>Business Analytics</i>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.facebook.com/Reliancejewels"
                  title="Follow Reliancejewels.com on Facebook"
                  target="_blank"
                >
                  <i className="fa fa-facebook-f" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.instagram.com/Reliancejewels/"
                  title="Follow Reliancejewels.com on Instagram"
                  target="_blank"
                >
                  <i className="fa fa-instagram" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://www.youtube.com/c/RelianceJewelsOfficial"
                  title="Follow Reliancejewels.com on Youtube"
                  target="_blank"
                >
                  <i className="fa fa-youtube" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="https://reliancejewels.com/"
                  title="Brand Website"
                  target="_blank"
                >
                  <i className="fa fa-globe" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>

}